
import React, { useEffect, useRef } from "react";

import CardView from "./CardOffCamView";

function MemberView({ member }: { member: Member }) {
    const videoRef = React.useRef<HTMLVideoElement>(null);
    useEffect(() => {
        if (member?.stream && videoRef.current) {
            videoRef.current!.srcObject = member.stream;
        }
        if (member?.is_local && member?.is_video_on === false && videoRef.current) {
            videoRef.current!.srcObject = new MediaStream();
        }
    }, [videoRef, member])

    useEffect(() => {
        const video = videoRef.current;

        if (video) {
            const handlePause = () => {
                video.play();
            };

            const handleEnded = () => {
                video.play();
            };

            video.addEventListener('pause', handlePause);
            video.addEventListener('ended', handleEnded);

            return () => {
                video.removeEventListener('pause', handlePause);
                video.removeEventListener('ended', handleEnded);
            };
        }
    }, []);
    return (
        <div className="h-full w-full">
            {member?.is_local && !member.is_video_on ? (
                <CardView member={member} />
            ) : (
                <>
                    <div className="h-full  relative flex justify-center items-center border-zinc-200 ">
                        <>
                            {member?.is_local ? (
                                <>
                                    <video
                                        className={`object-cover  h-full w-full relative`}
                                        autoPlay={true}
                                        controls={true}
                                        playsInline={true}
                                        muted={true}
                                        ref={videoRef}
                                    />

                                </>
                            ) : (
                                <>
                                    <video
                                        className={`object-cover  h-full w-full  `}
                                        autoPlay={true}
                                        controls={true}
                                        playsInline={true}
                                        muted={false}
                                        ref={videoRef}
                                    />
                                    <div
                                        style={{ backgroundColor: "rgba(82, 82, 91, 0.5)" }}
                                        className=" text-white absolute top-2 right-3 bg-zinc-500 rounded-2xl"
                                    >
                                        {member?.pubkey ? (
                                            <p className="p-2">{member?.pubkey}</p>
                                        ) : (
                                            <p className="p-2">TrustKeys User</p>
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    </div>
                </>
            )}
        </div>

    );
}

export default MemberView